/* eslint-disable react/prop-types */
import PropTypes from "prop-types";

import Dropdown from "@shared/v2/Dropdown";
import Checkbox from "@shared/v2/Checkbox";

const CustomOptionMultiAgent = ({ componentProps, children }) => (
  <Dropdown.Option
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...componentProps}
    className={`!tw-flex tw-gap-[8px] tw-items-center tw-group ${componentProps.data.currentUser ? "tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-gray-10" : ""}`}
    preserveStyle
  >
    <Checkbox checked={componentProps.isSelected} disabled={componentProps.isDisabled} readOnly />
    {children}
    {componentProps.data.currentUser && <span className="tw-text-gray-50"> (signed-in user)</span>}
  </Dropdown.Option>
);

export default CustomOptionMultiAgent;

CustomOptionMultiAgent.propTypes = {
  componentProps: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};
